import axios from 'axios';
import store from '../../store/store';
import { requestLogin, successLogin, failureLogin } from '../../actions/AuthActions';

export const tokenVerificationAragon = () => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');
  const appSrc = url.searchParams.get('appSrc');

  const config = store.getState((state) => state.config);
  const { ARAGON_URL } = config.config;

  // ~~ simulation mocks
  // const tokenOk = 'd4zzcrg56wpqgkqlzemsxav8jiydwfsy';
  // const tokenKo = 'ehtibrfgc6hx12tue828yb69xkjn8e425';
  // const tokenKo2 = 'xwckgvy29vn54257khmn42g2zztvippi5';
  // const token = tokenKo2;

  store.dispatch(requestLogin());

  axios
    .post(`${ARAGON_URL}`, {
      token,
      appSrc
    })
    .then((response) => {
      if (response.data.result === 'OK') {
        store.dispatch(successLogin(response.data.infoUser.email));
      } else {
        console.error('TOKEN_NOT_VALID');
        store.dispatch(failureLogin('TOKEN_NOT_VALID'));
      }
    })
    .catch((error) => {
      store.dispatch(failureLogin('TOKEN_NOT_VALID'));
      console.error('ERROR VERIFYING ARAGON TOKEN');
      console.error(error);
    });
};
